import BrandPeyaPlusInverted from '@pedidosya/web-fenix/icons/BrandPeyaPlusInverted';
import { useMemo, useState } from 'react';
// @ts-ignore
import { STATE, vendorItemVariants } from '@/src/utils/constants';
import { translate } from '@/src/utils/translate/translate';
import Image from '@pedidosya/web-fenix/foundations/Image';

import {
  ConditionsInfoRow,
  HeadlineRow,
  ShippingInfoRow,
  VendorStatusLarge,
  VendorStatusMedium,
} from './components';
import {
  Body,
  BodyRightColumn,
  CardContainer,
  Content,
  DividerWeb,
  Header,
  HeaderBottomRow,
  HeaderBottomRowLeftColumn,
  HeaderBottomRowRightColumn,
  HeaderCenterRow,
  HeaderContent,
  HeaderOverlay,
  HeaderTopRow,
  TagWeb,
} from './styles/styles';

const a11yLabels = translate.ARG_UY.vendorItem;

export const VendorItemDesktop = ({
  vendorName,
  variant,
  isNew,
  rating,
  occasion,
  deliveryETAVariant,
  deliveryFeeVariant,
  labels,
  images,
  delivery,
  status,
  renderPlusTag,
  onClick,
  hideDivider,
}) => {
  const [currentState, setCurrentState] = useState(STATE.IDLE);

  const {
    mainCategoriesLabels,
    conditionLabels,
    sponsoringLabel,
    discountLabel,
  } = labels || {};
  const {
    distance,
    deliveryFee,
    deliveryFeeWithDiscount,
    deliveryTime,
    pickupTime,
    hasSurgeFee,
  } = delivery;

  const handleOnClick = (e) => {
    setCurrentState(STATE.PRESSED);
    onClick(e);
  };

  const handleMouseEnter = () => {
    setCurrentState(STATE.HOVER);
  };

  const isHeaderOn = useMemo(
    () => variant === vendorItemVariants.headerOn,
    [variant],
  );

  const shouldRenderSponsoringLabelInBody = useMemo(() => {
    if (!sponsoringLabel) return false;

    return !isHeaderOn;
  }, [sponsoringLabel, isHeaderOn]);

  return (
    <CardContainer
      role="region"
      aria-label={`Local ${vendorName}`}
      tabIndex={0}
      withBorder={false}
      withShadow={false}
      state={currentState}
      onClick={handleOnClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setCurrentState(STATE.IDLE)}
      onPointerDown={() => setCurrentState(STATE.PRESSED)}
      onPointerCancel={() => setCurrentState(STATE.IDLE)}
      onPointerUp={() => setCurrentState(STATE.IDLE)}
    >
      {!isHeaderOn && (status?.title || status?.action) && (
        <VendorStatusMedium
          data-testid="vendor-status-medium"
          title={status?.title}
          action={status?.action}
        />
      )}
      {isHeaderOn && (
        <Header data-testid="vendor-item-header">
          {status?.showOverlay && (
            <HeaderOverlay data-testid="header-overlay" />
          )}
          <Image
            className="header-image"
            alt={a11yLabels.images.header}
            src={images.header}
            // Dimensions overridden via CSS
          />
          <HeaderContent>
            <HeaderTopRow>
              {!!status && status.action && !status.showOverlay && (
                <TagWeb
                  className="vendor-status-action"
                  category="informative"
                  size="medium"
                  label={status.action}
                />
              )}
            </HeaderTopRow>

            {!!status && status.showOverlay && (
              <HeaderCenterRow>
                <VendorStatusLarge
                  data-testid="vendor-status-large"
                  title={status.title}
                  action={status.action}
                />
              </HeaderCenterRow>
            )}

            <HeaderBottomRow>
              {(!!discountLabel || !!renderPlusTag) && (
                <HeaderBottomRowLeftColumn>
                  {!!discountLabel && (
                    <TagWeb
                      category="deals-and-discounts"
                      label={discountLabel}
                    />
                  )}
                  {renderPlusTag && (
                    <TagWeb
                      category="peya-plus"
                      label="Plus"
                      icon={<BrandPeyaPlusInverted />}
                    />
                  )}
                </HeaderBottomRowLeftColumn>
              )}

              {!!sponsoringLabel && (
                <HeaderBottomRowRightColumn>
                  <TagWeb
                    size="small"
                    category="quiet"
                    label={sponsoringLabel}
                  />
                </HeaderBottomRowRightColumn>
              )}
            </HeaderBottomRow>
          </HeaderContent>
        </Header>
      )}
      <Body>
        <Content>
          <BodyRightColumn>
            <HeadlineRow
              isNew={isNew}
              rating={rating}
              vendorName={vendorName}
              mainCategories={mainCategoriesLabels}
              discountLabel={discountLabel}
              renderPlusTag={renderPlusTag}
              sponsoringLabel={sponsoringLabel}
              shouldRenderSponsoringLabelInBody={
                shouldRenderSponsoringLabelInBody
              }
            />

            {(!!deliveryTime ||
              !!deliveryFee ||
              !!pickupTime ||
              !!distance) && (
              <ShippingInfoRow
                occasion={occasion}
                distance={distance}
                deliveryFeeWithDiscount={deliveryFeeWithDiscount}
                deliveryFee={deliveryFee}
                deliveryTime={deliveryTime}
                pickupTime={pickupTime}
                deliveryETAVariant={deliveryETAVariant}
                deliveryFeeVariant={deliveryFeeVariant}
                hasSurgeFee={hasSurgeFee}
              />
            )}

            {!!conditionLabels && conditionLabels.length > 0 && (
              <ConditionsInfoRow conditions={conditionLabels} />
            )}
          </BodyRightColumn>
        </Content>
      </Body>
      {!hideDivider && <DividerWeb />}
    </CardContainer>
  );
};
